import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Spinner } from '@wartek-id/spinner'

import { CardSchool } from 'app/KinerjaPage/components/CardSchool'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import { useApiGetPenilaianSchoolList } from 'api/kinerja/kepala-sekolah/school'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'

interface DialogSelectSchoolPenilainPeriodikProps
  extends Omit<DialogProps, 'children'> {
  onClickSchool?: () => void
}

export default function DialogSelectSchoolPenilaianPeriodik({
  isOpen,
  onClose,
  onClickSchool,
}: DialogSelectSchoolPenilainPeriodikProps) {
  const { tipe } = useKinerjaTipe()
  const { data: schools, isSuccess } = useApiGetPenilaianSchoolList({
    params: { tipe },
    options: {
      staleTime: 60 * 60 * 1000, // 1 hour
    },
  })

  const schoolLength = schools?.data?.length || 0
  const ctaText = schoolLength > 1 ? 'Lakukan Penilaian' : 'Pilih'

  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        customSize={596}
        autoFocus={false}
      >
        <DialogOverlay />
        <DialogContent
          className="rounded-lg m-auto self-center"
          aria-labelledby="periodik-pilih-satdik-title"
        >
          <div className="rounded-t-lg flex p-6 justify-between items-center bg-surface-subdued">
            <Text as="h2" variant="heading-md" id="periodik-pilih-satdik-title">
              Pilih satuan pendidikan
            </Text>
            <Button
              color="white"
              iconOnly
              size="sm"
              variant="ghost"
              className="!outline-none"
              onClick={() => onClose()}
            >
              <Icon color="inherit">close</Icon>
            </Button>
          </div>
          <div className="flex py-4 px-6 flex-col gap-4 max-h-[640px] overflow-y-auto">
            {isSuccess ? (
              schools.data.map((school) => (
                <CardSchool
                  fullWidth
                  key={school.npsn}
                  ctaText={ctaText}
                  ctaLabel={`${ctaText} ${school.schoolName}`}
                  baseHref={`${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/periodik`}
                  school={{
                    ...school,
                    statusSatuanPendidikan: 'NEGERI',
                    perencanaanReadyState: 'COMPLETED',
                  }}
                  onClick={onClickSchool}
                />
              ))
            ) : (
              <div className="flex justify-center items-center p-2">
                <Spinner data-testid="loading-spinner" />
              </div>
            )}
          </div>

          <div className="p-6">
            <Button fullWidth color="white" onClick={() => onClose()}>
              Kembali
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
